import { NavigationProvider, useModal } from "@/contexts";
import {
    useNewNavigate,
    useSetAddress,
    useSetBookingRecoilState,
    useSetBookingYeogiRecoilState,
    useSetPensionNameState,
    useSetToggleState,
} from "@/shared/client";
import { useGetDMaxBaseInfo } from "@/shared/server";
import { Box } from "@chakra-ui/react";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Outlet, useLocation } from "react-router-dom";
import { Footer } from "./footer";
import { Header } from "./header";
import { Intro } from "./intro";

export const Layout = () => {
    const { data } = useGetDMaxBaseInfo();
    const { onNavigate } = useNewNavigate();
    const { navigation, logoURL, address, tel, account, biz, pension_name: pensionName, calendar, intro } = { ...data };
    const { pathname } = useLocation();
    const { closeModal } = useModal();
    const setToggleState = useSetToggleState();
    const setBookingEngineState = useSetBookingRecoilState();
    const setBookingYeogiState = useSetBookingYeogiRecoilState();
    const setPensionName = useSetPensionNameState();
    const setAddress = useSetAddress();

    const navigationData = {
        navigation: {
            roomList: navigation?.roomList || [],
            specialList: navigation?.specialList || [],
        },
    };
    const pensionInfo = {
        name: {
            kor: pensionName?.kor || "",
            eng: pensionName?.eng || "",
        },
        address: address?.new || "",
        bizNumber: biz?.number || "",
        account: {
            use: account?.use || false,
            number: account?.number || "",
        },
        tel: {
            use: tel?.use || false,
            number: tel?.number || "",
        },
    };

    const excludedPaths = ["/home", "location", "/about", "/specials", "/rooms", "/reserve", "/guide"];

    const shouldShowIntro = intro?.used === true && !excludedPaths.some((path) => pathname.includes(path));

    useEffect(() => {
        const scrollRoot = document.getElementById("scrollRoot");
        if (scrollRoot) {
            scrollRoot.scrollTo({ top: 0 });
        }
        setToggleState(false);
        closeModal();
    }, [pathname]);
    useEffect(() => {
        if (pensionName) {
            setPensionName(pensionName);
            if (calendar) {
                setBookingEngineState(calendar.mmax_URL);
                if (calendar.yeogi.used) {
                    if (calendar.yeogi.url) setBookingYeogiState(calendar.yeogi.url);
                }
            }
            if (address) {
                setAddress(address.new);
            }
        }
    }, [data]);

    useEffect(() => {
        if (intro) {
            if (!intro.used) onNavigate({ path: "/home" });
        }
    }, [intro]);
    return (
        <>
            <Helmet>
                <title>{pensionInfo?.name.kor}</title>
            </Helmet>
            {shouldShowIntro ? (
                <Intro introGroup={intro.introGroup} />
            ) : (
                <Box id="scrollRoot" overflowY="auto" maxH="100vh">
                    <Header navigation={navigation} logoUrl={logoURL} pensionInfo={pensionInfo} />
                    <NavigationProvider value={navigationData}>
                        <Outlet />
                    </NavigationProvider>
                    <Footer logoUrl={logoURL} pensionInfo={pensionInfo} calendar={calendar} />
                </Box>
            )}
        </>
    );
};
